<template>
    <ul class="list--unstyled hide--mobile">
        <li class="is--size"
            v-for="size in sizes"
            :key="size.indicator"
            :class="[{ 'is--active': size.indicator === plexipeople.size }, 'is--size-' + size.indicator.toLowerCase()]"
            @click="resize(size)">
            <span class="is--info-size">{{ $t('visualization.max') }} {{ size.label }}</span>
        </li>
    </ul>
</template>

<script>
    export default {
        props: {
            sizes: Array,
            plexipeople: Object
        },

        methods: {
            resize(size) {
                this.$emit('resize', this.plexipeople, size);
            }
        }
    }
</script>

<style lang="scss" scoped>
    @import "../assets/scss/components/plexipeaople-visualization";
</style>



// WEBPACK FOOTER //
// src/components/PlexipeopleVisualization.vue